import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const AccountHeadEdit = ({ match }) => {
    const recordId = match.params.id;
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, token, logout]);

    const [formData, setFormData] = useState({
        CompanyId: companyId,
        Code: '',
        Description: '',
        IsPackingSlipExpense: false,
        IsIncome: false,
        UpdatedBy: userId,
        isSubmit: false,
    });

    useEffect(() => {
        fetchData('AccountHeadApi', `/AccountHead/${recordId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                    setFormData(prevData => ({
                        ...prevData,
                        UpdatedBy: userId,
                    }));
                }
            })
            .catch((error) => {
                console.error('Error fetching Account Head Details:', error);
            });
    }, []);

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : (type === 'radio' ? (value === 'true') : value),
        }));
    };

    const handleSubmit = event => {
        event.preventDefault();

        setIsLoading(true);
        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: userId,
        }));

        updateData('AccountHeadApi', `${recordId}`, formData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/AccountHeadIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setIsLoading(false);
            });
    };

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">
            <form onSubmit={handleSubmit}>
                <div className='w-full mb-2 flex items-center'>
                    <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>ACCOUNT HEAD EDIT</h6>

                    <Tooltip title="Exit">
                        <Link to="/AccountHeadIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                            <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                                Back To List <ArrowForwardIosIcon />
                            </Button>
                        </Link>
                    </Tooltip>


                    <Tooltip title="Update">

                        <Button onClick={handleSubmit} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "Update"} <CheckCircleIcon />
                        </Button>

                    </Tooltip>

                </div>

                <div className="w-full mb-4 flex">
                    <div className="w-4/5 mr-2">
                        <label className="block tracking-wide text-gray text-base font-bold mb-2" htmlFor="name">
                            Account Head Name
                            <span className="text-red-500">*</span>
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={formData.Description}
                            onChange={handleChange}
                            name='Description'
                            type="text"
                            placeholder="Enter Name"
                        />
                    </div>

                    <div className="w-full sm:w-1/5 pl-2 mb-2 sm:mb-0">
                        <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="code">
                            Code
                            <span className="text-red-500">*</span>
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={formData.Code}
                            onChange={handleChange}
                            name='Code'
                            type="text"
                            placeholder="Enter Code"
                        />
                    </div>
                </div>

                <div className="w-full mb-4 flex">

                    <div className="w-full sm:w-1/5 pl-2 mb-2 sm:mb-0">
                        <label className="block text-gray-700 text-base font-bold mb-2">
                            Income / Expense
                        </label>
                        <div>
                            <label className="inline-flex items-center">
                                <input
                                    type="radio"
                                    className="form-radio h-4 w-4 text-green-500 border-4 border-gray-400 rounded-full checked:bg-green-500 checked:border-transparent"
                                    name="IsIncome"
                                    value={true}
                                    checked={formData.IsIncome === true}
                                    onChange={handleChange}
                                />
                                <span className="ml-2"> <strong>Income</strong></span>
                            </label>
                            <label className="inline-flex items-center ml-6">
                                <input
                                    type="radio"
                                    className="form-radio h-4 w-4 text-green-500 border-4 border-gray-400 rounded-full checked:bg-green-500 checked:border-transparent"
                                    name="IsIncome"
                                    value={false}
                                    checked={formData.IsIncome === false}
                                    onChange={handleChange}
                                />
                                <span className="ml-2"> <strong>Expense</strong></span>
                            </label>
                        </div>
                    </div>

                    {/* <div className="w-full sm:w-1/5 pl-2 mb-2 sm:mb-0">
                        <label className="block text-gray-700 text-base font-bold mb-2">
                            Is Packing Slip Expense?
                        </label>
                        <div className="inline-flex items-center">
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4 text-green-500 border-4 border-gray-400 rounded-md checked:bg-green-500 checked:border-transparent"
                                name="IsPackingSlipExpense"
                                checked={formData.IsPackingSlipExpense}
                                onChange={handleChange}
                            />
                            <span className="ml-2 font-bold">Is Packing Slip Expense</span>
                        </div>
                    </div> */}
                </div>

            </form>
        </div>
    );
};

export default AccountHeadEdit;
